import React, { useState, memo, useEffect, useRef } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { VideoPlayIcon }  from '../../common/utilities/svg/videoPlayIcon';
import {  mediumMediaQuery } from '../../../common/utilities/sizeHelpers';
import { translate } from '../../../common/translation/translate';
import { LazyLoadImg } from '../../../common/utilities/lazyLoadImg';


export const ThumbnailImageBody = memo(({ storyImageUrl, hasVideoLinkUrl }) => {
    const [ imgLoadError, setImageLoadError ] = useState(false);

    const handleImageError = () => {
        setImageLoadError(true);
    };

    return (
        <>
            { storyImageUrl && !imgLoadError
                ? <LazyLoadImg style={imgStyle}
                                alt='WeatherBug Story Image'
                                width={imgStyle.width}
                                height={imgStyle.height}
                                src={storyImageUrl}
                                handleImageLoadError={handleImageError} />
                : imgLoadError && <NoStoriesImageThumbnail>{translate('imageFailedToLoad')}</NoStoriesImageThumbnail> }
            { hasVideoLinkUrl && <PlayIconContainer> <VideoPlayIcon /> </PlayIconContainer> }
        </>
    );
});

ThumbnailImageBody.displayName = 'StoryThumbnail';

ThumbnailImageBody.propTypes = {
    storyImageUrl: PropTypes.string,
    hasVideoLinkUrl: PropTypes.string
};


const imgStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
};

const PlayIconContainer = styled.div`
    display: flex;
    position: absolute;
    justify-content: center;
    top: 60%;
    right: 70%;
    @media ${mediumMediaQuery} {
        right: 80%;
    }

`;

const NoStoriesImageThumbnail = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    width: 100%;
    height: 100%;
`;
